import { ORGANIZATION_ROLE, ORGANIZATION_ROLE_NAME } from '@solid/shared';
import { useContext, useState } from 'react';
import { AuthContext } from '../../contexts/auth.context';
import styles from './AccountDeletion.module.scss';
import AccountDeletionForm from './AccountDeletionForm';
import { Button } from '@solid/shared/ui';
import { Link } from 'react-router-dom';
import { Trans, useTranslation } from 'react-i18next';

const AccountDeletion: React.FC = () => {
  const [active, setActive] = useState(false);
  const { auth } = useContext(AuthContext);
  const { t } = useTranslation();
  return (
    <div className={styles.wrapper}>
      {!active && (
        <button className='btn is-danger' onClick={() => setActive(true)}>
          <Trans
            i18nKey='pages.settingsAccount.accountDeletion.deleteAccountButton'
          />
        </button>
      )}
      {active && (
        <div className={styles.active}>
          {!auth.org && (
            <>
              <Trans
                i18nKey='pages.settingsAccount.accountDeletion.deleteAccountText'
                components={{ b: <b />, p: <p /> }}
              />
              <AccountDeletionForm />
            </>
          )}

          {auth.org &&
            (auth.orgMember.role === ORGANIZATION_ROLE.LOCAL_ADMIN ? (
              <>
                <p>
                  <Trans
                    i18nKey='pages.settingsAccount.accountDeletion.deleteAccountOrgAdminText'
                    components={{ b: <b />, p: <p /> }}
                    values={{
                      role: ORGANIZATION_ROLE_NAME[auth.orgMember.role],
                      org: auth.org.displayName,
                    }}
                  />
                </p>
                <p>
                  <Link to='mailto:info@solid-app.de'>
                    <Button themeColor='danger'>
                      {t('pages.settingsAccount.accountDeletion.contactSupportButton')}
                    </Button>
                  </Link>
                </p>
              </>
            ) : (
              <>
                <Trans
                  i18nKey='pages.settingsAccount.accountDeletion.deleteAccountOrgUserText'
                  components={{ b: <b />, p: <p/> }}
                  values={{
                    org: auth.org.displayName,
                  }}
                />
                <AccountDeletionForm deletionNeedsConfirmation />
              </>
            ))}
        </div>
      )}
    </div>
  );
};

export default AccountDeletion;
